export const optionsFromExpandableTable = (props) => {
  const {
    expandableTableData,
    changePageValues,
    setChangePageValues,
    selectedVal,
  } = props.dataObject;
  const { dynamicEntityDataMapping } = props.operation;
  if (dynamicEntityDataMapping && dynamicEntityDataMapping.mapping) {
    const tableData = expandableTableData[selectedVal];
    dynamicEntityDataMapping.mapping.forEach((mapping) => {
      const fromFieldIds = Array.isArray(mapping.fromFieldId)
        ? mapping.fromFieldId : [mapping.fromFieldId];
      fromFieldIds.forEach((fromFieldId) => {
        if (fromFieldId in tableData) {
          changePageValues[mapping.toFieldId] = tableData[fromFieldId] || '';
        }
      });
    });
    setChangePageValues({ ...changePageValues });
  }
};
